<template>
  <div class="modal fade" role="dialog" tabindex="-1" v-bind:class="{show: visible, 'd-block': visible}">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{title}}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="close">
              Close
            </button>
            <button type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="save">
              Save
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: ['title'],
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    start() {
      this.visible = true;
    },
    cancel() {
      this.close();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    save() {
      this.$emit('save');
      this.visible = false;
    },
  },
};
</script>
